module.exports = __webpack_public_path__ + "static/review-85380a329b574ffa209697682f6952ec.jpg";